<template>
    <nav v-if="totalPage > 1" class="pagination-wrapper" aria-label="Page navigation">
      <ul :class="`pagination ${paginationClass}`">
        <li class="page-item" :class="{ disabled: currPage === 1 }">
          <a class="page-link" href="#" @click.prevent="prevPage"><</a>
        </li>
        
        <!-- 页码列表 - 简化版：只显示当前页附近的页码 -->
        <li v-if="currPage > 2" class="page-item">
          <a class="page-link" href="#" @click.prevent="setPage(1)">1</a>
        </li>
        <li v-if="currPage > 3" class="page-item disabled">
          <a class="page-link" href="#">...</a>
        </li>
        
        <!-- 当前页附近的页码 -->
        <li v-for="page in getDisplayPages" 
            :key="page" 
            class="page-item"
            :class="{ active: page === currPage }">
          <a class="page-link" href="#" @click.prevent="setPage(page)">{{ page }}</a>
        </li>
        
        <li v-if="currPage < totalPage - 2" class="page-item disabled">
          <a class="page-link" href="#">...</a>
        </li>
        <li v-if="currPage < totalPage - 1" class="page-item">
          <a class="page-link" href="#" @click.prevent="setPage(totalPage)">{{ totalPage }}</a>
        </li>
        
        <li class="page-item" :class="{ disabled: currPage === totalPage }">
          <a class="page-link" href="#" @click.prevent="nextPage">></a>
        </li>
      </ul>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'BlogPagination',
    props: {
      // 总数据数
      totalItems: {
        type: Number,
        required: true,
        default: 0
      },
      // 每页展示数量
      itemsPerPage: {
        type: Number,
        default: 10
      },
      // 当前页码（允许外部控制）
      currentPage: {
        type: Number,
        default: 1
      },
      // 分页样式类
      paginationClass: {
        type: String,
        default: ''
      },
      // 滚动控制
      scrollControl: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        // 内部维护的当前页，默认使用props传入的值（如果未传则为1）
        currPage: this.currentPage
      }
    },
    computed: {
      // 计算总页数
      totalPage() {
        // 避免除零错误
        if (this.itemsPerPage <= 0) return 1;
        return Math.ceil(this.totalItems / this.itemsPerPage);
      },
      
      // 计算显示的页码范围（当前页附近的页码）
      getDisplayPages() {
        let start = Math.max(this.currPage - 2, 1);
        let end = Math.min(start + 4, this.totalPage);
        
        // 确保显示5个页码（如果可能）
        if (end - start < 4) {
          start = Math.max(end - 4, 1);
        }
        
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
      }
    },
    watch: {
      // 监听外部传入的当前页变化，同步到内部状态
      currentPage(newVal) {
        this.currPage = newVal;
      },
      
      // 监听总数据数变化，重新计算分页
      totalItems() {
        this.adjustCurrentPage();
      },
      
      // 监听每页数量变化，重新计算分页
      itemsPerPage() {
        this.adjustCurrentPage();
      }
    },
    methods: {
      // 调整当前页，确保在有效范围内
      adjustCurrentPage() {
        // 如果当前页超出了新的总页数范围，调整到最后一页
        if (this.currPage > this.totalPage) {
          this.currPage = Math.max(1, this.totalPage);
          // 只有当页码确实变化时才触发事件
          if (this.currentPage !== this.currPage) {
            this.$emit('pageChanged', this.currPage);
          }
        }
      },
      
      // 设置当前页
      setPage(pageNum) {
        // 边界检查
        if (pageNum === this.currPage || pageNum < 1 || pageNum > this.totalPage) {
          return;
        }
        
        this.currPage = pageNum;
        
        // 滚动控制
        if (this.scrollControl) {
          this.$emit('scrollControl');
        } else {
          window.scrollTo(0, 0);
        }
        
        // 触发事件，返回当前页码
        this.$emit('pageChanged', this.currPage);
      },
      
      // 上一页
      prevPage() {
        if (this.currPage > 1) {
          this.setPage(this.currPage - 1);
        }
      },
      
      // 下一页
      nextPage() {
        if (this.currPage < this.totalPage) {
          this.setPage(this.currPage + 1);
        }
      }
    },
    created() {
      // 组件创建时确保当前页在有效范围内
      this.adjustCurrentPage();
    },
    mounted() {
      // 初始触发一次，确保父组件知道当前页
      // 只有当总页数大于1时才触发，避免不必要的事件
      if (this.totalPage > 1) {
        this.$emit('pageChanged', this.currPage);
      }
    }
  }
  </script>  